export * from './abcp-ui.module';
//REV-21368 — the shared vocabulary of the document flow. `documents-hub.types` re-exports the
//same declarations, so both paths resolve to one symbol and the barrel stays unambiguous.
export * from './types/closing-documents.types';

// REV-21370 / REV-21364 — the correction-booking flow (ADR-0015). The shared vocabulary FIRST, for
// the same reason the document types are exported first: both views re-export nothing of their own,
// so the barrel stays unambiguous.
export * from './types/closing-adjustments.types';
export * from './components/adjustment-status/adjustment-status.component';
export * from './components/closing-adjustments/closing-adjustments.component';
export * from './components/account-adjustments/account-adjustments.component';
export * from './components/adjustment-modal/adjustment-modal.component';
export * from './components/adjustment-detail/adjustment-detail.component';

// REV-21375 — the correction-booking DATA layer. Beside the documents slice in the same module, for
// the same reason: the pure views inject no store, so a consumer of a dumb component must not have
// to drag a slice along.
export * from './models/closing-adjustment.model';
export * from './actions/closing-adjustment.actions';
export * from './reducer/closing-adjustment.feature-key';
export * from './reducer/closing-adjustment.reducer';
export * from './selectors/closing-adjustment.selectors';
export * from './services/closing-adjustment.service';
export * from './effects/closing-adjustment.effects';
export * from './provider/closing-adjustment.provider';
export * from './components/account-documents/account-documents.component';
export * from './components/account-documents/account-documents.types';
export * from './components/account-ledger/account-ledger.component';
export * from './components/account-ledger/account-ledger.types';
export * from './components/account-workspace/account-workspace.component';
export * from './components/account-workspace/account-workspace.types';
export * from './components/accounts-overview/accounts-overview.component';
export * from './components/accounts-overview/accounts-overview.types';
export * from './components/status-pie/status-pie.component';
export * from './components/activity-log/activity-log.component';
export * from './components/activity-log/activity-log.types';
export * from './components/account-notes/account-notes.component';
export * from './components/account-notes/account-notes.types';
export * from './components/account-todos/account-todos.component';
export * from './components/account-todos/account-todos.types';
export * from './components/mention-input/mention-input.component';
export * from './components/mention-input/mention-text';
export * from './components/document-detail/document-detail.component';
export * from './components/document-detail/document-detail.types';
export * from './components/document-detail/document-detail-slots.directive';
export * from './components/document-preview/document-preview.component';
export * from './components/document-preview/document-preview.types';
// REV-21369 — der Beleg-Viewer (ADR-0021).
export * from './components/pdf-viewer/pdf-viewer.component';
export * from './components/pdf-viewer/pdf-viewer.types';
export { PDFJS_VERSION } from './components/pdf-viewer/pdfjs-loader';
export * from './components/documents-hub/documents-hub.component';
export * from './components/documents-hub/documents-hub.types';
export * from './components/sort-header/sort-header.component';
export * from './components/sort-header/sort-header.types';
export * from './components/upload-modal/upload-modal.component';
export * from './components/upload-modal/upload-modal.types';
export * from './components/workspace-header/workspace-header.component';
export * from './components/workspace-header/workspace-header.types';

// The ABCP DATA layer — the store slices and HTTP services. Deliberately a separate module from
// `AbcpUiModule`: the pure views inject no Store and do no HTTP, and a consumer of a dumb component
// must not have to drag a store feature along. Two slices, documents and accounts.
export * from './abcp-data.module';
export * from './abcp-data.config';

// The documents of a closing.
export * from './models/closing-document.model';
export * from './actions/closing-document.actions';
export * from './reducer/closing-document.feature-key';
export * from './reducer/closing-document.reducer';
export * from './selectors/closing-document.selectors';
export * from './services/closing-document.service';
export * from './effects/closing-document.effects';
export * from './provider/closing-document.provider';

// The accounts of a closing, and the views over them.
export * from './models/project-account.model';
export * from './models/statement-layout.model';
export * from './actions/project-accounts.actions';
export * from './reducer/project-accounts.reducer';
export * from './selectors/project-accounts.selectors';
export * from './services/project-accounts.service';
export * from './effects/project-accounts.effects';
export * from './provider/project-accounts.provider';
export * from './constants/account-positions.constant';
export * from './constants/account-functions.constant';
export * from './components/chart-of-accounts/chart-of-accounts.component';
export * from './components/chart-of-accounts/chart-of-accounts.types';
export * from './presenters/chart-of-accounts.presenter';
export * from './components/closing-overview/closing-overview.component';
export * from './presenters/closing-overview.presenter';
export * from './components/erp-sync-progress/erp-sync-progress.component';
export * from './components/erp-sync-progress/erp-sync-progress.types';
export * from './components/erp-sync/erp-sync.component';
export * from './components/erp-sync/erp-sync.types';
// REV-22007 — the file route (ADR-0020): the workspace's re-import dialog and the template builder.
export * from './components/erp-file-import/erp-file-import.component';
export * from './components/erp-file-import/erp-file-import.types';
export * from './presenters/trial-balance-template';
export * from './presenters/accounting-file.presenter';
export * from './presenters/closing-setup-start.presenter';
export * from './presenters/closing-import.presenter';
export * from './presenters/accounts-presentation';
export * from './presenters/evaluate-statement';
export * from './presenters/statement-rows';
export * from './presenters/account-live-refresh';
export * from './presenters/balance-sheet.presenter';
export * from './presenters/income-statement.presenter';
export * from './presenters/trail.presenter';
export * from './presenters/trail-paging';
// REV-22010 — the closed-list i18n keys of the AI pipeline's document feedback (both views + the host's banner).
export * from './presenters/document-feedback-keys';
export * from './presenters/document-ai-state';
export * from './presenters/document-preview-content';

// REV-21378 — das Aktivitätslog: die menschliche Hälfte, der Mischer und der Presenter.
export * from './services/closing-activity.service';
export * from './presenters/activity-merge';
export * from './presenters/activity.presenter';
// REV-21354 — the Setup-Wizard: the slice behind it, and the two pure views it drives.
export * from './models/closing-setup.model';
export * from './actions/closing-setup.actions';
export * from './reducer/closing-setup.reducer';
export * from './selectors/closing-setup.selectors';
export * from './services/closing-setup.service';
export * from './effects/closing-setup.effects';
export * from './effects/accounting-file.errors';
export * from './provider/closing-setup.provider';
export * from './components/closing-setup-wizard/closing-setup-wizard.component';
export * from './components/closing-setup-wizard/closing-setup-wizard.types';
export * from './components/closing-import-banner/closing-import-banner.component';
export * from './components/closing-import-banner/closing-import-banner.types';
export * from './components/notes-overview/notes-overview.component';
export * from './components/notes-overview/notes-overview.types';
export * from './components/note-detail/note-detail.component';
export * from './components/note-detail/note-detail.types';
export * from './services/closing-note.service';
export * from './provider/closing-note.provider';
export * from './presenters/closing-note.presenter';
export * from './actions/closing-note.actions';
export * from './components/closing-constellation/closing-constellation.component';
export * from './models/account-ledger.model';
export * from './actions/account-ledger.actions';
export * from './reducer/account-ledger.reducer';
export * from './selectors/account-ledger.selectors';
export * from './services/account-ledger.service';
export * from './effects/account-ledger.effects';
export * from './provider/account-ledger.provider';
export * from './presenters/account-ledger.presenter';
export * from './services/closing-settings.service';
